var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZidiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 278,
    viewBox: "0 0 361 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.688 52.04H133.248L33.152 207.56H127.744V221H6.784L107.52 65.48H18.688V52.04ZM150.87 52.04H165.334V221H150.87V52.04ZM190.37 52.04H225.186C243.191 52.04 257.954 55.6667 269.474 62.92C280.994 70.088 289.485 80.0293 294.946 92.744C300.493 105.459 303.266 120.008 303.266 136.392C303.266 152.861 300.535 167.453 295.074 180.168C289.613 192.883 281.122 202.867 269.602 210.12C258.082 217.373 243.277 221 225.186 221H190.37V52.04ZM204.578 65.608V207.432H224.034C239.053 207.432 251.255 204.403 260.642 198.344C270.114 192.285 277.069 183.965 281.506 173.384C286.029 162.717 288.333 150.472 288.418 136.648C288.503 122.824 286.327 110.579 281.89 99.912C277.453 89.2453 270.455 80.8827 260.898 74.824C251.426 68.68 239.138 65.608 224.034 65.608H204.578ZM323.02 52.04H337.484V221H323.02V52.04Z",
    fill: "#314B66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    width: 113,
    height: 25,
    fill: "#F6B21B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZidiLogo);
export default __webpack_public_path__ + "static/media/zidi-logo.e5bc2ffe62fa90043d9622d8f07d2a8d.svg";
export { ForwardRef as ReactComponent };